import { SearchFacetAccordionItem } from 'modules/search/components/Facet/AccordionItem/SearchFacetAccordionItem';
import { SearchFacetDropdown } from 'modules/search/components/Facet/Dropdown/SearchFacetDropdown';
import { SearchFacetRadioButtonOptions } from 'modules/search/components/Facet/Options/SearchFacetRadioButtonOptions';
import { SEARCH_COMMON_REFINEMENT_LABELS } from 'modules/search/constants/refinements/searchCommonRefinementTypes';
import {
  useSearchLocation,
  useSearchRadius,
} from 'modules/search/contexts/SearchContext';
import { isPointGeotype } from 'modules/search/helpers/isPointGeotype';
import { useSearchFacetSelectedValue } from 'modules/search/hooks/facets/useSearchFacetSelectedValue';
import { useSearchRadiusOptions } from 'modules/search/hooks/facets/useSearchRadiusOptions';
import type { SearchRefinementVariant } from 'modules/search/types/SearchRefinementVariant';

type Props = {
  variant?: SearchRefinementVariant;
};

export function RadiusFacet({ variant = 'dropdown' }: Props) {
  const searchLocation = useSearchLocation();

  const FacetVariant =
    variant === 'accordion' ? SearchFacetAccordionItem : SearchFacetDropdown;

  const options = useSearchRadiusOptions();
  const searchRadius = useSearchRadius();
  const searchRadiusFromURL = useSearchFacetSelectedValue('radius');

  if (!searchLocation || !isPointGeotype(searchLocation.geoType)) return null;

  return (
    <FacetVariant
      icon="bulls-eye"
      facetType="radius"
      label={SEARCH_COMMON_REFINEMENT_LABELS.radius}
    >
      <SearchFacetRadioButtonOptions
        facetType="radius"
        initialValue={searchRadius || searchRadiusFromURL}
        options={options}
      />
    </FacetVariant>
  );
}
